<template>
  <el-container class="home-container">
    <el-header height="46px">
      <span class="text">{{tenantName}}</span>
      <div class="headerRight">
             <!-- <div class="username mesbox" style="margin-right:18px;" @click="xiaoxiFn">
               <i class="el-icon-message-solid"></i>
                <el-badge :value="msgNum" class="item" :hidden="msgNum==0">
                  消息通知
                </el-badge>
             </div> -->
      <el-dropdown class="my-dropdown">
        <span class="el-dropdown-link">
          <!-- 头像 用户名称 -->
          <img class="avatar" src="../../../assets/images/loginer.png" alt />
          <span class="username">{{name}}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-edit-outline" @click.native="setting()">修改密码</el-dropdown-item>
          <el-dropdown-item icon="el-icon-unlock" @click.native="logoutV2()">退出登录</el-dropdown-item>
          <!-- <el-dropdown-item icon="el-icon-s-home" @click.native="goHome()">回到首页</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
        </div>
    </el-header>
    <div class="box1" v-if="tenantList.length>0">
      <h3>选择租户</h3>
      <!-- <p>数量：<span class="num">{{tenantList.length}}</span></p> -->
    </div>
      <ul class="box">
        <li class="boxItem" v-for="(item,index) in tenantList" :key="index" :style="{ background:color[index%4] }" @click="tenantFN(item)">
          <i class="fa fa-university" aria-hidden="true"></i>
          <h4>{{item.tenantName}}</h4>
        </li>
      </ul>
      <div class="box1" v-if="businessList.length>0">
      <h3>选择业务</h3>
      <!-- <p>数量：<span class="num">{{businessList.length}}</span></p> -->
    </div>
      <ul class="box">
        <li class="boxItem" v-for="(item,index) in businessList" :key="index" :style="{ background:color[index%4] }" @click="tenantFN(item)">
          <i class="fa fa-truck" aria-hidden="true"></i>
          <h4>{{item.tenantName}}</h4>
        </li>
      </ul>
    <div class="footer">技术支持：中物（北京）物流信息服务有限公司</div>
    <el-dialog
        title="修改密码"
        :visible.sync="changePawDialog"
        width="420px"
        center
        @close="closeDialog"
        class="inpBox jiaoyan"
        :close-on-click-modal="false" :close-on-press-escape="false"
      >
        <el-form
          :model="changePaw"
          status-icon
          :rules="rules"
          ref="changePaw"
          label-width="150px"
          class="demo-ruleForm"
          size="mini"
        >
          <el-form-item label="旧密码" prop="passwordOld">
            <el-input
              type="password"
              v-model="changePaw.passwordOld"
              autocomplete="off"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item
            label="新密码"
            prop="passwordNew"
          >
            <el-tooltip class="item" effect="dark" content placement="top-end">
              <div slot="content">
                长度为6-20个字符
                <br />必须包含数字，大小写字母
                <br />不允许有特殊字符
              </div>
              <el-input
                type="password"
                v-model="changePaw.passwordNew"
                autocomplete="off"
                show-password
                maxlength="20"
              ></el-input>
            </el-tooltip>
          </el-form-item>
          <el-form-item
            label="确认密码"
            prop="checkPass"
          >
            <el-tooltip class="item" effect="dark" content placement="top-end">
              <div slot="content">
                长度为6-20个字符
                <br />必须包含数字，大小写字母
                <br />不允许有特殊字符
              </div>
              <el-input
                type="password"
                v-model="changePaw.checkPass"
                autocomplete="off"
                show-password
                maxlength="20"
              ></el-input>
            </el-tooltip>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('changePaw')">提交</el-button>
            <el-button @click="resetForm('changePaw')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
  </el-container>
</template>
<script>
import store from '@/store'
import { receiveMsgNoReadList, receiveMsgNoReadSum, readMsg } from '@/api/common'
import { encryption } from '@/utils/util'
export default {
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.changePaw.passwordNew) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      tenantName: localStorage.getItem('tenantName'),
      color: ['#0b4fd6', '#125dce', '#125dce', '#0b4fd6'],
      tenantList: [],
      businessList: [],
      name: localStorage.getItem('userName'),
      changePawDialog: false,
      changePaw: {
        passwordOld: '',
        passwordNew: '',
        checkPass: ''
      },
      rules: {
        passwordOld: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        passwordNew: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '请输入至少6位的密码', trigger: 'blur' },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z]{6,20}$/, message: '密码设置不符合要求' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' },
          { min: 6, message: '请输入至少6位的密码', trigger: 'blur' },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z]{6,20}$/, message: '密码设置不符合要求' }
        ]
      },
      msgNum: 0,
      timeInterval: '600000', // 消息定时器时长
      tiemr: null,
      notifyPromise: Promise.resolve()
    }
  },
  created () {
    let arr = JSON.parse(localStorage.getItem('tenantList'))
    arr.forEach(item => {
      if (item.flag) {
        this.businessList.push(item)
      } else {
        this.tenantList.push(item)
      }
    })
    // this.getMsg()
    // this.tiemr = setInterval(this.getMsg, this.timeInterval)
  },
  methods: {
    tenantFN (item) {
      localStorage.setItem('isBusiness', item.flag ? 1 : 2)// 1业务获取菜单,2租户获取菜单
      localStorage.setItem('createTenantCode', item.tenantCode)
      localStorage.setItem('createTenantName', item.tenantName)
      this.$router.push({ path: '/' })
    },
    getMsg () {
      receiveMsgNoReadList({
        timeInterval: this.timeInterval,
        userType: 1
      }).then(res => {
        res.forEach(item => {
          this.notify(item)
        })
      })
      receiveMsgNoReadSum({
        userType: 1
      }).then(res => {
        this.msgNum = res
      })
    },
    notify (item) {
      let that = this
      this.notifyPromise = this.notifyPromise.then(this.$nextTick).then(() => {
        this.$notify({
          title: item.messageTitle,
          // dangerouslyUseHTMLString: true,
          //  message: item.messageContent,
          position: 'bottom-right',
          onClick: function () {
            that.$router.push({ name: 'messageLook', query: { id: item.id } })
          }
        })
      })
    },
    xiaoxiFn () {
      this.$router.push('/messageNotification')
    },
    // el-dropdown-item 绑定事件  不支持click
    // 当你给组件绑定事件的时候，如果组件没有支持这个事件，当然不会触发。
    // click是原生dom拥有的事件，目的给组件渲染后的dom绑定事件
    // 事件修饰符，例如 @click.prevent="函数"  阻止默认行为  @click.native 把原生事件绑定在组件上
    // https://cn.vuejs.org/v2/guide/events.html#%E4%BA%8B%E4%BB%B6%E4%BF%AE%E9%A5%B0%E7%AC%A6
    // 消息公告
    // 去设置页面
    getData () {
      return function () {}
    },
    setting () {
      this.changePawDialog = true
    },
    // 回到首页
    goHome () {
      this.$router.push('/website')
    },
    // 退出登录
    logoutV2 () {
      this.$axios
        .get(this.global.commonNameV2 + '/oauth/remove/token')
        .then(res => {
          store.delUser()
          localStorage.clear()
          sessionStorage.clear()
          this.$router.push('/login')
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
    },
    // 修改密码 适用v1和v2
    submitForm (formName) {
      let data = encryption({
        data: this.changePaw,
        key: this.global.key,
        param: ['passwordOld', 'passwordNew']
      })
      let data1 = {
        passwordOld: data.passwordOld,
        passwordNew: data.passwordNew
      }
      let url = this.global.commonNameV2
      // console.log(data1)
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios({
            method: 'post',
            url: url + '/user/changePwd',
            params: data1
          })
            .then(res => {
              this.$message('修改密码成功请重新登录')
              this.logoutV2()
            }).catch(error => {
              console.log(error)
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                }
              })
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    closeDialog () {
      this.$refs.changePaw.resetFields()
    }
  },
  destroyed () {
    clearInterval(this.tiemr)
  }
}
</script>

<style scoped lang='less'>
// FE  front end  前端工程师
// el-container 自定义标签是一个组件  渲染后的结构div span section  默认在标签上架上一个和组件名称一致的类名
.home-container {
  background-color: #001529;
  background:url('../../../assets/images/selectOrgBg.jpg') 100%;
}
.box1{
   width: 70%;
   display: flex;
   margin: 0 auto;
   justify-content: space-between;
   color: #fff;
   .h3{
    letter-spacing:4px;
   }
   .num{
     color: #e89805;
   }

}
.box{
  width: 70%;
  display: flex;
  margin: 0 auto;
  flex-wrap: wrap;
  .boxItem{
    width: 50%;
    height: 20vh;
    padding: 80px 0 60px;
    box-sizing: border-box;
    background: cornflowerblue;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    color: #fff;
    letter-spacing:2px;
    .fa{
      font-size: 40px;
    }
  }
  .boxItem:hover{
    background: #00d0c0!important;
  }
}
.footer{
  position: fixed;
  bottom:18px;
  width: 100%;
  font-size: 12px;
  color: #fff;
  text-align: center;
}
.home-container {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  .el-header {
    background-color: #0c46a2;
    line-height: 46px;

    .icon {
      font-size: 24px;
      vertical-align: middle;
      padding-right: 10px;
    }
    .text {
      font-family: Source Han Sans CN;
      font-size: 22px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 37px;
      color: #fff;
    }
    .headerRight{
      float: right;
      display: flex;
      .mesbox{
        display: flex;
        margin-right: 8px;
        align-items: center;
      }
      .el-badge__content{
        top:8px;
        border: none;
      }
      .el-icon-message-solid{
        font-size: 14px;
        margin-right: 4px;
      }
      .avatar {
        width: 30px;
        height: 30px;
        vertical-align: middle;
        display: inline-block;
      }
      .username {
        color: #fff;
        vertical-align: middle;
        font-size: 12px;
        margin-left: 4px;
        cursor: pointer;
      }
      .el-icon-arrow-down {
        color: #fff;
      }
    }
  }
}
.el-main {
  height: calc(100vh - 46px);
}
.el-submenu__title i {
  color: #fff;
}

.footerBtn {
  text-align: center;
  margin: 20px;
}
.dialogInp {
  background: #dbe5ef;
  padding: 20px 0;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 12px;
}
.diqu1 {
  .el-form-item__content {
    .el-input__inner {
      width: 460px;
    }
  }
}
.jiage .el-form-item__content {
  position: relative;
  .danwei {
    position: absolute;
    right: 4px;
    color: #9c9797;
  }
}

.el-table td,
.el-table th {
  padding: 2px 0 !important;
}
.el-main {
  padding-bottom: 0 !important;
}
.inpBox .el-input__inner {
  width: 150px;
}
.remark .el-input .el-input__inner {
  width: 480px;
}
.gjh {
  height: 60px;
}
.gjh .el-input__inner {
  height: 100%;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 6px;
}
.jiaoyan .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 16px !important;
}
.searchBox {
  display: flex;
}
.searchBox .gjhBox .el-form-item {
  display: flex;
}
.gjhBox {
  flex-shrink: 0;
}
.gjhBox /deep/.el-textarea__inner {
  width: 150px;
  height: 60px;
}

.margin0 {
  margin: 0 !important;
}
.red {
  color: #ff0000;
  font-size: 14px;
  margin: 0 4px;
  font-family: Source Han Sans CN;
}
.el-dialog .el-dialog__body {
  padding: 10px 20px;
}
.el-input.is-disabled .el-input__inner {
  border: none;
  background: #dcedff;
}

// 按钮样式
.el-button--primary {
  background-color: #0c46a2;
}
.el-button--primary:focus,
.el-button--primary:hover {
  background: #0b59bd;
  border-color: #0b59bd;
  color: #fff;
}
.el-button {
  padding: 7px 15px;
}
.el-button--text {
  padding: 0;
}
.bigBtn {
  padding: 12px 28px;
}
.el-button--text {
  color: #0c46a2;
}
.el-button--text:focus,
.el-button--text:hover {
  color: #0b59bd;
}
// 表格样式
.el-table th {
  background-color: #f5f5f5;
  height: 40px;
  color: #333333;
}
.el-table {
  color: #333;
}
.el-table tr {
  height: 32px;
}
.el-table tr:nth-child(even) {
  background-color: #f8fafd;
}
.el-table__body tr.hover-row > td {
  background-color: rgba(14, 110, 236, 0.3);
}
.el-table__body tr.current-row > td {
  background-color: rgba(14, 110, 236, 0.3);
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(14, 110, 236, 0.3);
}
.el-table__body tr:hover {
  background-color: rgba(14, 110, 236, 0.3) !important;
}
.el-table .cell {
  text-align: center;
}

//表单颜色
.el-form-item__label {
  color: #333;
}
// 弹框样式
.el-message-box__header {
  border-bottom: 1px solid #dcdfe6;
}
.el-message-box__title {
  font-size: 16px;
  color: #333;
}
.el-message-box__content {
  color: #333;
}
.el-dialog__headerbtn {
  top: 12px;
  .el-dialog__close {
    color: #fff;
  }
}
.el-dialog__title {
  color: #fff;
}
.el-dialog__header {
  padding: 8px 20px;
  background-color: #0c46a2;
  border-radius: 4px 4px 0 0;
}
.el-dialog--center {
  border-radius: 4px 4px 0 0;
}
//发布货源
.addressBox {
  .title {
    margin-top: 0;
    margin-left: 10px;
    font-size: 16px;
    .iconFont {
      color: #0c46a2;
    }
  }
  .el-button--text {
    padding: 0;
    margin: 0 4px;
  }
}
hr {
  width: 100%;
  height: 1px;
  border: none;
  border-top: dashed 1px #dcdfe6;
}
.el-form--inline .diqu {
  display: flex;
  .el-form-item__content {
    display: flex;
    flex-direction: column;
    .el-input__inner {
      width: 240px;
    }
  }
}
.iconFont {
  margin-right: 4px;
  font-size: 14px;
}
.el-date-editor.el-input {
  width: auto;
}
.inpBox .el-date-editor .el-input__inner {
  width: 180px;
}
.el-upload--picture-card {
  background-image: url(../../../assets/images/upload.png);
  background-size: 150%;
  background-position:50% 50%;
}
.disabled .el-input__inner {
  background: #dcedff;
}
// 详情页title
.detailsTitle {
  display: flex;
  justify-content: space-between;
  padding-right: 10px 10px;
  margin-left: 10px;
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 10px;
  h4 {
    margin: 0;
    font-size: 16px;
    color: #333;
    padding-bottom: 10px;
    border-bottom: 2px solid #0c46a2;
  }
  .printBox h4 {
    display: inline-block;
    margin-right: 20px;
  }
  .fa-reply {
    padding-right: 10px;
    color: #0c46a2;
  }
}
body.el-loading-parent--relative {
  position: static !important;
}
.mar10 {
  margin-left: 10px;
}
// 提单详情
.ydxq {
  display: flex;
  color: #fff;
  background: #4894f6;
  margin: 0;
  flex-wrap: wrap;
  padding-left: 10px;
}
// 抽屉样式
.el-drawer__header {
  height: 40px;
  background: #0c46a2;
  padding: 0 0 0 10px;
  color: #fff;
  margin: 0;
}
.el-drawer__body {
  overflow: auto;
  padding-bottom: 48px;
}
.footerBox {
  text-align: center;
  position: absolute;
  bottom: 0px;
  width: 100%;
  padding: 10px;
  background: #fff;
}
.leftDrawer {
  width: 50%;
}
.rightDrawer {
  width: 50%;
  right: 0;
  left: auto;
}
.BtnBox {
  display: flex;
  margin: 10px;
  .el-button {
    margin-left: 8px;
  }
}
.el-table--mini,
.el-table--small,
.el-table__expand-icon {
  font-size: 14px;
}
// 表格错位问题
body .el-table th.gutter:last-of-type {
    display: block!important;
    width: 17px!important;
 }
// 运单的车辆监控
.vehm .el-dialog__body{
padding: 0;
}
.amap-icon img{
  width: 32px;
  height: 32px;
}
.amap-sug-result {
  z-index: 999999;
}
.is-need:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
    }
.el-table__empty-block{
       align-items: stretch!important;
}
.el-cascader-node>.el-radio{
  visibility: hidden!important;
}
.detail .box1 span{
  font-size: 14px!important;
}
.detail .el-date-editor .el-input__inner{
  font-size: 14px!important;
}
.timmHH .el-time-panel{//解决时间选择器需要选择到时
  display: none;
}
</style>
